import React from 'react';
import { Link } from 'react-router-dom';

// Enhanced Navigation Link Component using React Router
const EnhancedNavLink = ({ 
  to, 
  children, 
  style = {}, 
  className = '',
  onClick,
  ...props 
}) => {
  const defaultStyle = {
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    // Don't use 'inherit' for color as it can cause issues
    ...style
  };

  return (
    <Link 
      to={to} 
      style={defaultStyle} 
      className={className}
      onClick={onClick}
      {...props}
    >
      {children}
    </Link>
  );
};

// Enhanced Button Link Component for button-style navigation
const EnhancedButtonLink = ({ 
  to, 
  children, 
  style = {}, 
  className = '',
  variant = 'primary',
  size = 'medium',
  onClick,
  ...props 
}) => {
  const baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    fontFamily: 'DM Sans, sans-serif',
    fontWeight: '500',
    gap: '8px'
  };

  const variantStyles = {
    primary: {
      background: 'linear-gradient(135deg, #D7B377 0%, #E2D7C4 100%)',
      color: '#1A202C',
      border: '1px solid #D7B377'
    },
    secondary: {
      background: 'transparent',
      color: '#D7B377',
      border: '1px solid #D7B377'
    },
    outline: {
      background: 'transparent',
      color: '#2C3A4C',
      border: '1px solid #2C3A4C'
    }
  };

  const sizeStyles = {
    small: {
      padding: '8px 16px',
      fontSize: '12px'
    },
    medium: {
      padding: '12px 20px',
      fontSize: '14px'
    },
    large: {
      padding: '16px 24px',
      fontSize: '16px'
    }
  };

  const combinedStyle = {
    ...baseStyle,
    ...variantStyles[variant],
    ...sizeStyles[size],
    ...style
  };

  return (
    <Link 
      to={to} 
      style={combinedStyle} 
      className={className}
      onClick={onClick}
      {...props}
    >
      {children}
    </Link>
  );
};

export { EnhancedNavLink, EnhancedButtonLink };
export default EnhancedNavLink;